import { ReactElement } from "react"
import tw, { styled } from "twin.macro"

const externalIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>`

export const proseStyle = (element: ReactElement) => styled(element)`
  ${tw`text-lg`}

  *:where(h2, h3, h4):not(:last-child) {
    margin-bottom: 0.5em;
  }

  h4 {
    font-size: 1.5em;
  }

  h5 {
    font-size: 1.25em;
    font-weight: 600;
  }

  a[target*="_blank"] {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;

    &::after {
      content: "";
      width: 1em;
      height: 1em;
      display: block;
      margin-left: 0.25em;
      background-image: url("data:image/svg+xml;utf8,${externalIcon}");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }

  a.play-store-btn,
  a.app-store-btn {
    display: block;
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
    text-indent: -1000em;
    height: 2.5em;
    margin-top: 0.25em;

    &:hover {
      opacity: 0.85;
    }

    &::after {
      content: none;
    }
  }

  a.play-store-btn {
    background-image: url("/google-play-badge.png");
    aspect-ratio: 3.36 / 1;
  }

  a.app-store-btn {
    background-image: url("/ios-app-store.svg");
    aspect-ratio: 3 / 1;
    height: 2.75em;
  }

  * + :is(ul, ol) {
    margin-top: 1em;
  }

  ul:not([class]) {
    ${tw`list-disc [marginLeft:1.5em]`}
  }

  ol:not([class]) {
    ${tw`[listStyle:decimal] [marginLeft:2em]`}
  }

  ol[type="a"] {
    list-style-type: lower-alpha;
  }
  ol[type="i"] {
    list-style-type: lower-roman;
  }

  .embedded-entity {
    .field {
      display: none;
    }

    figure,
    img {
      margin: 0;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .btn {
    &,
    a {
      text-decoration: none;
    }

    &--pill > a {
      display: inline-flex;
      align-items: center;

      > span {
        max-width: 45vw;
        ${tw`text-xs md:text-base inline-block overflow-hidden`}
        text-overflow: ellipsis;
      }
    }

    &--pill {
      svg,
      a {
        margin-right: 0.45em;
      }
    }
  }

  figure img {
    height: auto;
    margin: 0;
  }

  .btn-primary {
    &,
    a {
      ${tw`no-underline bg-primary font-semibold px-8 py-3 whitespace-nowrap rounded-3xl hover:text-white hover:bg-black focus-visible:bg-orange focus-visible:text-white outline-none transition-colors`}
    }
  }

  ol.use-dp {
    list-style-type: none;
    counter-reset: item;

    ol:not([style]) > li,
    & > li {
      display: table;
      counter-increment: item;
      margin-bottom: 0.6em;

      &::before {
        content: counters(item, ".") ". ";
        display: table-cell;
        padding-right: 0.6em;
      }
    }

    ol:not([style]) {
      list-style-type: none;
      counter-reset: item;
    }

    li ol > li {
      margin: 0;
    }

    li ol:not([style]) > li::before {
      content: counters(item, ".") " ";
    }
  }

  details,
  details summary {
    list-style: none;
    background-image: none;
    -webkit-appearance: none;
  }

  summary {
    font-weight: 600;
    cursor: pointer;
    padding-block: 0.5rem;

    &:hover,
    &:focus-visible {
      color: var(--nova-primary-dark);
    }
  }

  details + details {
    border-top: 1px solid var(--nova-silver);
  }
`
